import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'signup-close_sign_up_modal-click';
/**
 * User clicked on the `x` button to close the sign up modal (non FD)
 */ export function trackSignupCloseSignUpModalClick() {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false
    });
}
